import { styled } from '@mui/material/styles';
import { TableCell } from 'shared/mui/Table';
import { TableCellHeader } from 'shared/mui/Table';

export const TableCellHeaderStyled = styled(TableCellHeader)(({ theme }) => ({
  verticalAlign: 'middle',
  fontSize: '14px',
  fontWeight: 400,
  color: theme.palette.secondary.main,
  padding: '8px 16px',
  height: '40px',
}));

export const TableCellStyled = styled(TableCell)({
  textWrap: 'wrap',
  wordBreak: 'break-all',
  padding: '8px 16px',
  height: '40px',
});
